module.exports = __webpack_public_path__ + "static/media/1.8b2fbd9a.jpg";